import type { DashboardDetail } from '../dashboardTypes';
import { formatInstant } from '../format';
import { eventLabel, valueLabel } from './statusCopy';

/**
 * Audit History tab (Figma S12, S26, S36, S42): the server's real events, newest first, never rewritten. Each shows what happened, who (a role, or "System"), when
 * (UTC, because the company time zone is not available in this module), the change of status and the reason. Actor names are not available (BACKEND GAP).
 */
export function AuditTab({ detail }: { detail: DashboardDetail }) {
  const entries = [...detail.timeline].reverse();
  return (
    <div className="tpd-tabbody" data-testid="tab-audit">
      {entries.length === 0 ? <p className="tpd-muted">No history has been recorded for this payment yet.</p> : (
        <ol className="tpd-timeline" aria-label="Audit history">
          {entries.map((e, i) => {
            const from = valueLabel(e.previousValue);
            const to = valueLabel(e.newValue);
            return (
              <li key={`${e.occurredAtUtc}-${e.eventType}-${i}`} className="tpd-timeline__item">
                <p className="tpd-timeline__title">
                  {eventLabel(e.eventType)}
                  {e.isSimulated && <span className="tpd-chip tpd-chip--sim">Simulated</span>}
                </p>
                <p className="tpd-muted">{e.byTheSystem ? 'System' : (e.actorRole ?? 'Unknown')} · {formatInstant(e.occurredAtUtc)}</p>
                {(from || to) && <p>{from ?? 'None'} → {to ?? 'None'}</p>}
                {e.reason && <p className="tpd-muted">Reason: {e.reason}</p>}
              </li>
            );
          })}
        </ol>
      )}
    </div>
  );
}
